"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraAndScreenCount = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _CameraAndScreenCount = require("./CameraAndScreenCount.styled");
var _Sources = require("@studio/constants/Sources");
var _constants = require("../../constants/");
var _ = require("./..");
var _hooks = require("../../hooks");
var _useTranslate2 = require("../../locales/useTranslate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CameraAndScreenCount = exports.CameraAndScreenCount = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var count = _ref.count,
    type = _ref.type,
    _ref$maxCameraSourceL = _ref.maxCameraSourceLimit,
    maxCameraSourceLimit = _ref$maxCameraSourceL === void 0 ? _Sources.MAX_CAMERA_COUNT : _ref$maxCameraSourceL;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var isCameraCount = type === 'camera';
  var icon = isCameraCount ? _freeSolidSvgIcons.faVideo : _freeSolidSvgIcons.faTv;
  var maxCount = isCameraCount ? maxCameraSourceLimit : _constants.MAX_SCREEN_SHARES;
  var color = count >= maxCount ? '#FFD33D' : isStudioLite ? '#6E7582' : '#8D91AF';
  var tooltipText = isCameraCount ? "A max of ".concat(maxCameraSourceLimit, " cameras can be active at a time") : translate('ScreenShareCount_Popover');
  var targetElementId = isCameraCount ? 'camera-count-wrapper' : 'screen-share-count-wrapper';
  return /*#__PURE__*/_react["default"].createElement(_CameraAndScreenCount.StyledWrapper, {
    id: targetElementId
  }, /*#__PURE__*/_react["default"].createElement(_CameraAndScreenCount.IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon,
    color: color
  })), /*#__PURE__*/_react["default"].createElement(_CameraAndScreenCount.StyledCount, {
    color: color
  }, count, "/", maxCount), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    targetElement: targetElementId,
    message: tooltipText,
    placement: 'top'
  }));
});
CameraAndScreenCount.propTypes = {
  count: _propTypes.number,
  type: (0, _propTypes.oneOf)(['camera', 'screen']),
  maxCameraSourceLimit: _propTypes.number
};